import React, { useEffect, useState } from 'react'
import CatalogueItem from './CatalogueItem'

export default function Catalogue({ addToCart }) {

    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetch('https://shoppingcart.anthonyscoding.cloud/products/products.json', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET',
            }}  )
            .then((response) => response.json())
            .then((data) => {
                setProducts(data)
            })
            .catch((error) => {
                console.error('Error fetching data:', error)
            })
    }, [])

  return (
    <main className="catalogue">
        <h2>Product Catalogue</h2> 
        <section className="products">
            {products.map((product) => (
                    <CatalogueItem
                        key={product.id}
                        name={product.name}
                        img={product.img}
                        description={product.description}
                        price={product.price}
                        product={product}
                        addToCart={addToCart}
                    />
                ))}

          </section>
      </main>
  )
}
